if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled()) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }

      get behindLayer() {
        return !!this.closest('[inert]') || document.body.matches('.has-modal-open, .has-modal-opening');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }
    
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.afterAgeGate(() => this.load(this.delay));
        }
      }

      // DA CUSTOM. The offer counts its delay from the moment the visitor is
      // past the age check, so it never opens underneath it
      afterAgeGate(callback) {
        const gate = document.getElementById('AgeVerifier');
        const testMode = gate && gate.getAttribute('data-test-mode') === 'true';
        if (!gate || (this.getCookie('concept:age-verifier') && !testMode)) {
          callback();
          return;
        }

        gate.addEventListener('modal:afterHide', () => callback(), { once: true });
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }

      show(activeElement = null, animate = true) {
        if (this.open) return;

        if (!Shopify.designMode && this.behindLayer) {
          this.showAfterLayer(activeElement, animate);
          return;
        }

        return super.show(activeElement, animate);
      }

      showAfterLayer(activeElement, animate) {
        if (this.layerObserver) return;

        this.layerObserver = new MutationObserver(() => {
          if (this.behindLayer) return;
          this.layerObserver.disconnect();
          this.layerObserver = null;
          this.show(activeElement, animate);
        });
        this.layerObserver.observe(document.body, { attributes: true, attributeFilter: ['inert', 'class'], subtree: true });
        this.registerCleanup(() => {
          this.layerObserver?.disconnect();
          this.layerObserver = null;
        });
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
